export default "__VITE_ASSET__89596a1e__"